/* unplugin-vue-components disabled */import script from "./HBoxList.vue?vue&type=script&setup=true&lang=ts"
export * from "./HBoxList.vue?vue&type=script&setup=true&lang=ts"

import "./HBoxList.vue?vue&type=style&index=0&id=9455a3b2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9455a3b2"]])

export default __exports__